import React from 'react'
import { TextFieldProps, TextField } from '@mui/material'
import { isNumeric } from 'common/utils'


export const NumericTextField = (props: TextFieldProps) => {
  const error = React.useMemo(() => {
    return props.value !== '' && !isNumeric(props.value)
  }, [props.value])
  return (
    <TextField
      {...props}
      error={error}
      helperText={error ? '数値を入力してください' : props.helperText}
      inputProps={{
        inputMode: 'numeric',
        pattern: '[0-9]*'
      }}
    />
  )
}
